import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { selectUiDefinitionTournamentSubCategory } from "../../balancingSelectors/selectBalancingUiDefinitions";
import { ScrollOptions } from "../../constants/ScrollOptions";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { EventType } from "../balancing/types/BalancingCore";
import { ProbationTimeOverlay } from "../cooperative/ProbationTimeOverlay";
import { TextLoca } from "../generic/text/TextLoca";
import { placementDivisions, placementLeaguesInfo } from "./IdLeaguePlacement";
import { mapEventTypeToSpecialCategories } from "./IdTournamentCategory";
import { LeaguePrizes } from "./LeaguePrizes";
export var TabLeagueOverviewContent = React.memo(function (_a) {
    var highlightedPlayerLeagueId = _a.highlightedPlayerLeagueId, selectedLeague = _a.selectedLeague;
    if (selectedLeague == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var uiPage = selectUiDefinitionTournamentSubCategory(mapEventTypeToSpecialCategories.get(selectedLeague));
    var title = (uiPage.locaKey || IdLoca.empty);
    var isCoopLeague = selectedLeague === EventType.CoopLeague;
    var Wrapper = isCoopLeague
        ? ProbationTimeOverlay
        : function (_a) {
            var children = _a.children;
            return React.createElement(React.Fragment, null, children);
        };
    var tabs = getTabs(selectedLeague, highlightedPlayerLeagueId);
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex flex--guts title-container" },
            React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: title })),
        React.createElement("div", { className: "" + IdStyles.LeaguesContainer },
            React.createElement(Wrapper, { idLoca: IdLoca.joinCoop_blockedTournament_desc },
                React.createElement(ScrollBar, { component: "div", options: ScrollOptions },
                    React.createElement("div", { className: "flex flex--guts flex--wrap" }, tabs))))));
});
var getTabs = function (selectedLeague, highlightedPlayerLeagueId) {
    return placementLeaguesInfo.map(function (league) {
        return placementDivisions.map(function (division) {
            var stars = division + 1;
            var leagueNumber = league.startsFrom + division;
            return (React.createElement(LeaguePrizes, { league: league, stars: stars, leagueId: leagueNumber, key: leagueNumber, highlightedLeagueId: highlightedPlayerLeagueId, leagueType: selectedLeague }));
        });
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/TabLeagueOverviewContent.tsx
// module id = 2787
// module chunks = 3